import {withRouter} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap';
import {useEffect, useState} from "react";
import {useWindowWidth} from "../helpers/useWindowWidth";
import Api from "../../services/Api";
import HelperGeneral from "../../helpers/HelperGeneral";
import {Button, Spin} from "antd";
import ReactHtmlParser from 'react-html-parser'
import UserInfo from "../auth/UserInfo";

const ProductLandingPage = ({match}) => {
    const [qrData, setQrData] = useState([]);
    const [descriptions, setDescriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const windowSize = useWindowWidth();
    const {qrcode} = match.params;


    useEffect(() => {
        if (!qrcode) return;
        const extracted = HelperGeneral.extractQrcodeFromUrlOrRaw(qrcode);
        const normalizedQrcode = extracted ? (extracted.full || extracted.code) : qrcode;
        const parts = String(normalizedQrcode).split('-');
        const finalCode = parts.length > 1 ? parts[1] : normalizedQrcode;
        getQrDetail(finalCode);
    }, []);

    const getQrDetail = (code) => {
        setLoading(true);
        Api.getPointCodeDetailPage(code).then(e => {
            if (!e?.data?.product) {
                setLoading(false);
                HelperGeneral.alert('Puan kodu geçersizdir.', null, null, '/anasayfa');
            } else {
                setQrData(e?.data);
                const descriptions = e?.data?.product?.descriptions?.map(item => ({
                    ...item,
                    title: item?.title && item.title.trim().length > 0 ? item.title : 'Diğer'
                })) || []

                setDescriptions(descriptions);
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            HelperGeneral.alert(e);
        });
    }

    const setPointCodeToUser = (code) => {
        if (!UserInfo.info()){
            localStorage.setItem('qrcode', code);
            HelperGeneral.alert(
                'Puan kodunuzun tanımlanması için sisteme giriş yapmanız gerekmektedir.',
                'info',
                null,
                '/giris-yap'
            );
            return;
        }

        setLoading(true);

        Api.transactionAdd({ code })
            .then(() => {
                HelperGeneral.alert('Puan kodunuz tanımlanmıştır.', 'success');
                localStorage.removeItem('qrcode');
            })
            .catch((e) => {
                HelperGeneral.alert(e, 'error', null, '/anasayfa');
                localStorage.removeItem('qrcode');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div className={'product-landing-page'}>
            <Spin spinning={loading} size={'large'}>
                <Container>
                    <Row>
                        <Col xs={12} md={5}>
                            <div className={'image-div h-100 w-100 d-flex align-items-center justify-content-center'}>
                                <img className={'product-img'}
                                     src={qrData?.product?.images && qrData?.product?.images[0] && qrData?.product?.images[0]?.w750x ? qrData?.product?.images[0]?.w750x : require('../../assets/images/png/default-product.png')}/>
                                <img className={'orzax-club-logo'}
                                     src={require('../../assets/images/png/theme/orzax-club-logo.png')}/>
                            </div>
                        </Col>
                        {
                            windowSize < 767 && (
                                <Col xs={12} className={'mb-3 mt-1'}>
                                    <div className={'separator-line'}/>
                                </Col>
                            )
                        }
                        <Col xs={12} md={7}>
                            <Container className={'p-0'}>
                                <Row>
                                    <Col xs={12}>
                                        <span className={'title green'}>{qrData?.product?.name ?? '-'}</span>
                                    </Col>
                                    <Col xs={12} className={'mb-3'}>
                                        {/*<div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span className={'date-title'}>Son Kullanma Tarihi:</span>
                                            <span className={'date green mx-1'}>{qrData?.lastUseDate ?? '-'}</span>
                                        </div>*/}
                                    </Col>
                                    <Col xs={12} className={'mb-2 mb-md-3'}>
                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span>Ürün Barkodu:</span>
                                            <span className={'green mx-1'}>{qrData?.product?.barcode ?? '-'}</span>
                                        </div>
                                    </Col>
                                    <Col xs={12} className={'mb-2 mb-md-3'}>
                                        <div className={'d-flex flex-row flex-wrap align-items-center gap-2'}>
                                            <span>Orzax Club Puan Kodunuz:</span>
                                            <span className={'green mx-1'}>{qrData?.code}</span>
                                            {(UserInfo.info('user_roles_id') === 3 || !UserInfo.info()) && (
                                                <Button
                                                    size="small"
                                                    onClick={() => setPointCodeToUser(qrData?.code)}
                                                    disabled={loading || !qrData?.code}
                                                    style={{
                                                        backgroundColor: '#6CA22C',
                                                        borderColor: '#6CA22C',
                                                        color: '#fff',
                                                        height: '32px'
                                                    }}
                                                >
                                                    Puan Kodunu Kullan
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                    <Col xs={12} className={'mb-4 mb-md-3'}>
                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span>Orzax Club Puan:</span>
                                            <span className={'green mx-1'}>{qrData?.points ?? '-'}</span>
                                        </div>
                                    </Col>
                                    <Col xs={12} className={'mb-4 mb-md-3'}>
                                        <div className={'separator-line'}/>
                                    </Col>
                                    <Col xs={12} className={'mb-4 mb-md-3'}>
                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span className={'spaced-text'}>Kategori</span>
                                            <span className={'gray'}>:</span>
                                            <span className={'gray mx-2'}>{qrData?.product?.category ?? '-'}</span>
                                        </div>
                                    </Col>
                                    <Col xs={12} className={'mb-4 mb-md-3'}>
                                        <div className={'separator-line'}/>
                                    </Col>
                                    <Col xs={12} className={'mb-2'}>
                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span className={'spaced-text'}>Mail</span>
                                            <span className={'gray'}>:</span>
                                            <span className={'gray mx-2'}><a href="mailto:info@shiniq.com">info@shiniq.com</a></span>
                                        </div>
                                    </Col>
                                    <Col xs={12} className={'mb-2'}>
                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span className={'spaced-text'}>Telefon</span>
                                            <span className={'gray'}>:</span>
                                            <span className={'gray mx-2'}><a href="https://wa.me/02124474737">0212 447 47 37</a></span>
                                        </div>
                                    </Col>
                                    <Col xs={12} className={'mb-0'}>
                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                            <span className={'spaced-text'}>Websitesi</span>
                                            <span className={'gray'}>:</span>
                                            <span className={'gray mx-2'}><a href="https://shiniq.com">https://shiniq.com</a></span>
                                        </div>
                                    </Col>
                                    {
                                        windowSize < 767 && (
                                            <Col xs={12} className={'my-4'}>
                                                <div className={'separator-line'}/>
                                            </Col>
                                        )
                                    }
                                </Row>
                            </Container>
                        </Col>
                        <Col xs={12} className={'mt-0 mt-md-3'}>
                            <Container className={'p-0'}>
                                <Row>
                                    <Col xs={12} className="mb-2">
                                        <div
                                            className="d-flex flex-row justify-content-start align-items-center tab-div">
                                            {descriptions.map((item, index) => (
                                                <span
                                                    key={index}
                                                    className={activeTab === index ? 'tab-title active' : 'tab-title'}
                                                    onClick={() => setActiveTab(index)}
                                                >
                                              {item.title}
                                            </span>
                                            ))}
                                        </div>
                                    </Col>

                                    <Col xs={12} className="mb-4">
                                        {descriptions.map((item, index) => (
                                            <div
                                                key={index}
                                                className={activeTab === index ? 'd-flex tab-content' : 'd-none'}
                                            >
                                           <span>
                                              {item?.description
                                                  ? ReactHtmlParser(item.description)
                                                  : '-'}
                                            </span>
                                            </div>
                                        ))}
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </Spin>
        </div>
    );
}

export default withRouter(ProductLandingPage);
